import React, { Component } from "react";
import { connect } from "react-redux";
import MediaQuery from "react-responsive";
import {
  Alert,
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  UncontrolledButtonDropdown,
} from "reactstrap";
import { bindActionCreators } from "redux";
import { Field, reduxForm } from "redux-form";
import { layout, roles } from "../../../../common/constants";
import { formatHelper, normalizeHelper } from "../../../../common/helpers";
import { DataTable, MainLoader } from "../../../../components";
import {
  getProduct,
  getProductStores,
  putProductStores,
  resetProduct,
  resetProductStores,
  resetStockProductStores,
} from "../../../../store/product/actions";
import { getIGV } from "../../../../store/sell/actions";
import { selectUserRole } from "../../../../store/user/selector";
import * as columns from "./_columns";
import { validate } from "./_validate";

class ProductDetail extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modalOpen: false,
      selectedStore: null,
    };

    //  this.toggleModal = this.toggleModal.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.optionsFormatterColumn = this.optionsFormatterColumn.bind(this);
  }

  async componentDidMount() {
    await this.props.getIGV();
    await this.props.getProduct(this.props.match.params.id);
    await this.props.getProductStores(this.props.match.params.id);
  }

  async onSubmit(values) {
    await this.props.putProductStores(
      this.props.match.params.id,
      values.minStock,
      this.state.selectedStore
    );
    await this.setState({
      modalOpen: !this.state.modalOpen,
    });
    await this.props.getProductStores(this.props.match.params.id);
  }

  componentWillUnmount() {
    this.props.resetProduct();
    this.props.resetProductStores();
    this.props.resetStockProductStores();
  }

  toggleModal(store_id) {
    this.setState({
      modalOpen: !this.state.modalOpen,
      selectedStore: store_id,
    });
  }

  renderField(label, value) {
    return (
      <FormGroup row>
        <Col md="2" lg="1">
          <Label color="red">{label}</Label>
        </Col>
        <Col xs="12" md="5">
          <p className="form-control-static">{value}</p>
        </Col>
      </FormGroup>
    );
  }
  renderImg(label, value) {
    return (
      <FormGroup row>
        <Col md="2" lg="1">
          <Label color="red">{label}</Label>
        </Col>
        <Col xs="2" md="2">
          <img style={{ width: "100%" }} src={value} />
        </Col>
      </FormGroup>
    );
  }

  renderFields() {
    const { product, igv } = this.props;
    const categoryName = product.category != null ? product.category.name : "";
    const providerName = product.provider != null ? product.provider.name : "";

    let value = "";
    if (igv) value = formatHelper.toMoney(product.price / (1 + 0.18));

    return (
      <div>
        {this.renderField("Nombre:", product.name)}
        {this.renderField("Código:", product.code)}
        {this.renderField("Precio (S/):", formatHelper.toMoney(product.price))}
        {this.renderField("Precio sin IGV (S/):", value)}
        {this.renderField("Costo (S/):", formatHelper.toMoney(product.cost))}
        {this.renderField("Descuento (%):", product.discount)}
        {this.renderField(
          "Precio Con Descuento (S/):",
          formatHelper.toMoney(product.price_discount)
        )}
        {product.app_name &&
          this.renderField("Nombre en aplicación móvil:", product.app_name)}
        {this.renderField("Puntos en aplicación móvil:", product.app_points)}
        {product.app_img && this.renderImg("Imagen Vertical:", product.app_img)}
        {product.app_img_flat &&
          this.renderImg("Imagen Horizontal:", product.app_img_flat)}
        {this.renderField("Categoría:", categoryName)}
        {this.renderField("Proveedor:", providerName)}
      </div>
    );
  }

  optionsFormatterColumn(cell, row) {
    if (this.props.role == roles.STORE_MANAGER) {
      return <div></div>;
    }
    return (
      <UncontrolledButtonDropdown>
        <DropdownToggle size="sm" color="primary">
          <i className="fa fa-bars"></i>
        </DropdownToggle>
        <DropdownMenu>
          <DropdownItem onClick={this.toggleModal.bind(this, row.store_id)}>
            <i className="fa fa-edit mr-1"></i> Modificar Stock
          </DropdownItem>
        </DropdownMenu>
      </UncontrolledButtonDropdown>
    );
  }

  renderInputField(field) {
    const {
      meta: { touched, error },
    } = field;
    const hasError = touched && error ? true : false;
    const labelClass = field.labelClass ? field.labelClass : "mt-1";

    return (
      <FormGroup row>
        <Col md="3">
          <Label className={labelClass}>{field.label}</Label>
        </Col>
        <Col md="9">
          <Input {...field.input} invalid={hasError} type={field.type} />
        </Col>
      </FormGroup>
    );
  }

  renderDataTable(columns, data, total, loading) {
    return (
      <DataTable
        data={data}
        keyField="id"
        columns={columns}
        totalSize={total}
        loading={loading}
      />
    );
  }

  render() {
    const columnOption = {
      dataField: "",
      text: "",
      formatter: this.optionsFormatterColumn,
      style: { width: "50px" },
      headerStyle: { width: "50px" },
    };

    const {
      product,
      loading,
      error,
      productStoresLoading,
      productStores,
      total,
      handleSubmit,
    } = this.props;

    if (error) {
      return <Alert color="danger">{error}</Alert>;
    }

    if (loading || productStoresLoading) {
      return <MainLoader />;
    } else if (!product) return <div></div>;

    return (
      <div className="animated">
        <Card>
          <CardHeader>Detalle del Producto</CardHeader>
          <CardBody>
            {this.renderFields()}
            <Row>
              <Col className="mt-3">
                <Button
                  color="secondary"
                  onClick={() =>
                    this.props.history.push("/administration/products")
                  }
                >
                  <i className="fa fa-chevron-left mr-1" /> Volver
                </Button>
              </Col>
            </Row>
            <br />
            <br />
            <Row>
              <Col>
                <MediaQuery maxWidth={layout.XS_MAX_WIDTH}>
                  {this.renderDataTable(
                    columns.productDetailXS(columnOption),
                    productStores,
                    total,
                    productStoresLoading
                  )}
                </MediaQuery>
                <MediaQuery
                  minWidth={layout.SM_MIN_WIDTH}
                  maxWidth={layout.MD_MAX_WIDTH}
                >
                  {this.renderDataTable(
                    columns.productDetailSM(columnOption),
                    productStores,
                    total,
                    productStoresLoading
                  )}
                </MediaQuery>
                <MediaQuery minWidth={layout.LG_MIN_WIDTH}>
                  {this.renderDataTable(
                    columns.productDetail(columnOption),
                    productStores,
                    total,
                    productStoresLoading
                  )}
                </MediaQuery>
              </Col>
            </Row>
          </CardBody>
        </Card>
        <Modal isOpen={this.state.modalOpen}>
          <Form onSubmit={handleSubmit(handleSubmit(this.onSubmit))}>
            <ModalHeader> Modificar Stock Mínimo</ModalHeader>
            <ModalBody>
              <Field
                name="minStock"
                label="Cantidad:"
                type="text"
                component={this.renderInputField}
                normalize={normalizeHelper.integerOnlyField(1)}
              />
            </ModalBody>
            <ModalFooter>
              <Row>
                <Col className="mt-3">
                  <Button type="submit" color="primary" className="mr-2">
                    <i className="fa fa-save mr-1" /> Guardar
                  </Button>
                  <Button
                    color="secondary"
                    onClick={this.toggleModal.bind(
                      this,
                      this.state.selectedStore
                    )}
                  >
                    <i className="fa fa-chevron-left mr-1" /> Cancelar
                  </Button>
                </Col>
              </Row>
            </ModalFooter>
          </Form>
        </Modal>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { product, error, loading } = state.product.activeProduct;
  const productStoresList = state.product.productStoresList;
  const { activeIGV } = state.sell;
  return {
    product,
    error,
    loading,
    igv: activeIGV.igv,
    productStores: productStoresList.productStores,
    productStoresLoading: productStoresList.loading,
    total: productStoresList.total,
    role: selectUserRole(state),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getProduct,
      resetProduct,
      getIGV,
      getProductStores,
      resetProductStores,
      putProductStores,
      resetStockProductStores,
    },
    dispatch
  );
}

export default reduxForm({
  form: "ProductDetailMinStockForm",
  touchOnBlur: false,
  // enableReinitialize: true,
  validate,
})(connect(mapStateToProps, mapDispatchToProps)(ProductDetail));



// WEBPACK FOOTER //
// ./src/scenes/Administration/Product/ProductDetail/ProductDetail.js